import { useState, useEffect } from 'react'

import Dialog from './Dialog'
import GridCheckbox from './GridCheckbox'
import GridMatchInfo from './GridMatchInfo'
import { titlesCalendari } from '../settings/settings'

const DialogOmologa = ({ open, handleClose, triggerFunction, gara }) => {
  const [omologa, setOmologa] = useState()

  useEffect(() => {
    setOmologa(gara?.validHomologation)
  }, [gara])

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      triggerFunction={() => triggerFunction(omologa)}
      title={titlesCalendari.titleEditOmologa}
      textConfirm='Salva'
      maxWidth='md'
    >
      <GridMatchInfo gara={gara}>
        <GridCheckbox
          label='Gara omologata'
          value={!!omologa}
          onChange={(_, x) => setOmologa(x)}
        />
      </GridMatchInfo>
    </Dialog>
  )
}

export default DialogOmologa
